import { Typography, Card, CardActionArea, CardContent, CardMedia, IconButton } from "@mui/material";
import { useHistory, Link } from "react-router-dom";
import { tss } from "tss-react";
import { getCachedData, deleteEntityFromCache } from "api/Cache";
import { formatDateDetailed } from "services/UtilsService";
import { defaultThumbnailIcon } from "constants/common";
import { viewCardBackground } from "styles/common";
import DeleteIcon from '@mui/icons-material/Delete';
import React, { useState } from "react";
import useSwalWrapper from 'themes/jumbo/@jumbo/vendors/sweetalert2/hooks';
import { useJumboDialog } from 'themes/jumbo/@jumbo/components/JumboDialog/hooks/useJumboDialog';
import { useSelector, useDispatch } from 'react-redux';
import { getAccessLevel } from "actions/ViewerTools";
import { DeleteItem } from "panels/DeleteItemsPanel";
import EventsEmitter from "events/EventsEmitter";
import FoldersActions from "actions/FoldersAction";
import {
    deleteViewFromCache
} from 'store/cache';

export const useStyles = tss.create(() => ({
    root: {
        marginLeft: 14,
        marginRight: 0,
        marginBottom: 16,
        marginTop: 10,
        width: 230,
        //padding:8,
        borderRadius: "12px",
        backgroundColor: viewCardBackground,
        boxShadow: "rgba(115, 82, 199, 0.176) 0px 0.5rem 1.25rem;",
        color: "rgb(71, 82, 89)",
        transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1)",
        overflow: 'hidden',
    },
    link: {
        textDecoration: "none",
        color: "#000000DE",
    },
    icon: {
        marginLeft: 25,
        cursor: "pointer",
    },
    media: {
        height: 158,
        borderTopLeftRadius: 6,
        borderTopRightRadius: 6
    },
    cardTitle: {
        fontSize: 20,
        fontWeight:500
    },
    cardInfo: {
        fontSize: 13,
        color: '#40404099'
    },
}));

type IProps = {
    view: any;
};

export default function ViewCard(props: IProps) {
    const { classes } = useStyles();
    const { view } = props;
    const projects: any = getCachedData("projects");
    const projectName = projects[view.project] ? projects[view.project].name : "Unknown Project";
    const date = formatDateDetailed(view.file_date);
    const [showButton, setShowButton] = useState<any>(false);
    const Swal = useSwalWrapper();
    const history = useHistory();
    const { showDialog, hideDialog } = useJumboDialog();
    const storeAuthData = useSelector((state: any) => state.auth);
    const { 
        hasActiveSubscription = false, 
        projectAccessLevel:access_level = "read", 
        defaultProjects,
    } = storeAuthData;
    const isDefaultProject = defaultProjects.includes(view.project);
    const projectAccessLevel = getAccessLevel(view.project);
    const hasProjectAccess = projectAccessLevel === 'full';
	const dispatch: any = useDispatch();

    const sweetAlerts = () => {
        Swal.fire({
        title: 'Your account has limited access!',
        text: 'We have limited your access to some features. Please upgrade your current plan to access this feature.',
        imageWidth: 450,
        imageHeight: 200,
        imageAlt: 'Custom image',
        confirmButtonText: "Upgrade my plan",
        showCloseButton: true,
        }).then((result) => {
            result.isConfirmed && history.push("/profile");
        });
    };

    const deleteAction = React.useCallback((evt: any) => {
        evt.stopPropagation();
        if (isDefaultProject || !hasActiveSubscription) {
            !hasActiveSubscription && sweetAlerts();
            return;
        }
        showDialog({
            variant: 'confirm',
            title: 'Are you sure?',
            content: 'Once you delete a project that cannot be reversed.',
            onYes: () => {
                FoldersActions.reloadCatalog(() => {
                    DeleteItem(defaultProjects, [view.ID], () => {
                        dispatch(deleteViewFromCache(view.ID));
                        deleteEntityFromCache(view.project, view.ID);
                    }, true)
                });
                hideDialog();
            },
            onNo: () => hideDialog(),
        });
    }, [showDialog, Swal, hideDialog]);
    
    const DeleteProjectsBtn = (props: { onClick? : () => void}) => {
        return (
            <div style={{
                display: 'flex', 
                justifyContent: 'end', 
                width: '100%', 
                position: 'absolute', 
                bottom: '10px', 
                left: '0px',
                paddingRight: '10px'
            }}>
                <span 
                    onClick={deleteAction}
                >
                    <DeleteIcon sx={{ fontSize: 20 }} />
                </span >
            </div>
        );
    }

    const handleClick = (evt: any) => {
        evt.preventDefault(); 
        history.push(`/views/${view.ID}`);
    };

    return (
        <Card>
            <CardActionArea
                onMouseEnter={() => setShowButton(true)}
                onMouseLeave={() => setShowButton(false)}
            >
                <a 
                    // to={"/views/" + view.ID} 
                    className={classes.link}
                    onClick={handleClick}
                >
                    <CardMedia
                        component='img'
                        height='160'
                        image={view.thumb ? view.thumb : defaultThumbnailIcon}
                        title={view.name}
                    />
                    <CardContent style={{ height:'160px', position: 'relative' }} sx={{ textAlign: 'center' }}>
                        <Typography  variant={'h4'} sx={{color: '#101010'}}>
                            {view.name}
                        </Typography>
                        <Typography>
                            {projectName}
                        </Typography>
                        <Typography variant={'h6'} color={'text.secondary'} sx={{ fontSize: 10 }}>
                            {date}
                        </Typography>
                        { hasProjectAccess && showButton && <DeleteProjectsBtn /> }
                    </CardContent>
                </a>
            </CardActionArea>
        </Card>
    );
}
